import { Model } from 'miragejs'

export default Model.extend({})
